module.exports = __webpack_public_path__ + "db04921e191f72598a31408efc7ad14d.svg";